import {AvatarSize} from '@gravity-ui/uikit';

export const emptyUserAvatar = 'https://avatars.mds.yandex.net/get-yapic/0/0-0/';

export const textSizeMap: Record<AvatarSize, string> = {
    xs: 'small',
    s: 'small',
    m: 'middle',
    l: 'middle',
    xl: '50',
};

export const isRetina = typeof window === 'object' && window.devicePixelRatio > 1;
